declare namespace $ {

	export class $bog_ainews_app_feed_img extends $mol_view {
		src( next?: any ): any
		alt( next?: any ): any
		width( next?: any ): any
		height( next?: any ): any
	}
	
}

//# sourceMappingURL=img.view.tree.d.ts.map